module.exports = __webpack_public_path__ + "img/teamImg19.ab8c1a9b.jpg";